import { useEffect, useState } from "react";
import ClientTableSafari from "./ClientTableSafari.js";
import ClientTableDefault from "./ClientTableNormal.js";

// Функция определения браузера
const isSafari = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isAppleDevice = /mac|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
  const isSafariBrowser = /safari/.test(userAgent) && !/chrome/.test(userAgent) && !/crios/.test(userAgent);

  // Safari на любых устройствах
  return isSafariBrowser || (isAppleDevice && /safari/.test(userAgent));
};

// Функция определения WebKit (для надёжности)
const isWebKit = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /webkit/.test(userAgent) && !/chrome/.test(userAgent) && !/edg/.test(userAgent);
};

function ClientTable(props) {
  const [isSafariBrowser, setIsSafariBrowser] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    // Определяем браузер при монтировании
    const safariDetected = isSafari() || isWebKit();
    setIsSafariBrowser(safariDetected);
    setIsMounted(true);
  }, []);

  // Пока не определили браузер — не рендерим ничего (или показываем заглушку)
  if (!isMounted) {
    return (
      <div className="data-table-loading">
        <div className="loading-spinner"></div>
        <div>Загрузка таблицы...</div>
      </div>
    );
  }

  // Рендерим нужную версию таблицы
  if (isSafariBrowser) {
    return <ClientTableSafari {...props} />;
  }

  return <ClientTableDefault {...props} />;
}

export default ClientTable;